<template>
<!--    <b-form-input v-model="quantity" class="project-item-quantity"-->
<!--                  type="number" min="0" aria-label="Text input with checkbox"-->
<!--                  @input="changeProductQuantity"-->
<!--    />-->
    <span v-if="quantityString == 1">{{ quantityProduct }}+</span>
    <span v-else>{{ quantityProduct }}</span>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "project-item-quantity",

        props: [
            'product_id',
            'quantity_product',
            'quantity_str'
        ],
        /**
         * Данные экземпляра компонента
         *
         */
        data() {
            return {
                quantity: "1",
                productId: this.product_id,
                quantityProduct: this.quantity_product,
                quantityString: this.quantity_str,
            }
        },

        computed: {
            ...mapGetters('productQuantity', [
                'productQuantity',
            ]),
        },

        mounted(){
        },


        methods: {
            changeProductQuantity(value){
                if (value <= 0) {
                    this.$nextTick(() => {
                        this.quantity = 1;
                    });
                } else {
                    this.$store.commit('productQuantity/setProductQuantity', {id: this.productId, quantity: value});
                }
            },
        }
    }
</script>
